import { Button, Grid, TextField, Typography } from "@material-ui/core";
import { Autocomplete, ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { geminiFileResponseSchema } from "./Utils/GeminiHandler";
import { formatLabel } from "./Utils/Helpers";
import { Replay } from "@material-ui/icons";
import { formatDttm } from "../../Util/timezone";

export default function Form(props) {
  const fieldList = Object.keys(geminiFileResponseSchema.items.properties).map(r => {
    const label = formatLabel(r);
    const isRequired = geminiFileResponseSchema.items.required.includes(r);
    const value = props.initialDataRecord[r] !== "null" ? props.initialDataRecord[r] || '' : '';

    return (
      <Grid key={r} item xs={12} md={6} lg={4}>
        <Typography>{label} {isRequired ? '*' : ''}</Typography>
        <TextField 
          value={value} 
          variant='outlined'
          fullWidth
          size="small"
          style={{marginTop: "5px", backgroundColor: "#FFFFFF"}}
          onChange={(e) => {
            const data = { ...props.initialDataRecord };
            data[r] = e.target.value || null;

            props.setInitialDataRecord(data);
          }}
        />
      </Grid>
    )
  });

  return (
    <>
      <Grid item xs={12} md={12} lg={12}>
        <Typography variant="h4">
          Step 2: Select Import Type & Refine Conversion
        </Typography>
        {/* <Typography>
          Please set the session name and choose the import type below.
        </Typography> */}
        <Typography>
          The data in the form is an initial conversion of the first record of the file. Refine each input in the form to ensure it aligns with what you want to see on the scan page.
        </Typography>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <Typography>Session Name (Defaults to filename or sessionId if not given a name)</Typography>
        <TextField 
          value={props.sessionName} 
          variant='outlined'
          fullWidth
          size="small"
          style={{marginTop: "5px", backgroundColor: "#FFFFFF"}}
          onChange={(e) => props.setSessionName(e.target.value)}
        />
      </Grid>
      {/* <Grid item xs={12} md={12} lg={12}>
        <Typography>Is this a new vendor import or a pricing update?</Typography>
        <ToggleButtonGroup 
          value={props.sessionType} 
          exclusive 
          size="small" 
          style={{marginTop: "5px"}} 
          onChange={(e, value) => {
            if (!value) return;

            props.setSessionType(value)
          }}
        >
          <ToggleButton value="new">New Import</ToggleButton>
          <ToggleButton value="update">Pricing Update</ToggleButton>
        </ToggleButtonGroup>
      </Grid> */}
      { props.sessionType === 'new' ? (
          <>     
            {fieldList}
          </>
        ) : (
          <>
            <Grid item xs={12} md={12} lg={12}>
              <Typography>Distributor Name</Typography>
              <Autocomplete
                id="distributor-selection"
                fullWidth
                style={{marginTop: "5px"}}
                value={props.selectedDistributor}
                options={props.distributorList}
                getOptionLabel={(option) => option.name}
                renderOption={(option) => (
                  <span>
                    <b>{option.name}</b>
                    <br></br>
                    {formatDttm(option.created_dttm, { format: 'M/D/YYYY' })}
                  </span> 
                )}
                onChange={(e, value) => props.setSelectedDistributor(value?.id ?? undefined)}
                renderInput={(params) => (
                  <TextField {...params} label="Distributor" variant="outlined" />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Typography>Manufacturer Name</Typography>
              <Autocomplete
                id="manufacturer-selection"
                fullWidth
                style={{marginTop: "5px"}}
                value={props.selectedManufacturer}
                options={props.manufacturerList}
                getOptionLabel={(option) => option.name}
                renderOption={(option) => (
                  <span>
                    <b>{option.name}</b>
                    <br></br>
                    {formatDttm(option.created_dttm, { format: 'M/D/YYYY' })}
                  </span> 
                )}
                onChange={(e, value) => props.setSelectedManufacturer(value?.id ?? undefined)}
                renderInput={(params) => (
                  <TextField {...params} label="Manufacturer" variant="outlined" />
                )}
              />
            </Grid>
          </>
        )
      }
      <Grid item xs={12} md={12} lg={12} style={{textAlign: "right"}}>
        <Button 
          variant="contained"
          onClick={() => props.reloadStep()}
          style={{backgroundColor: "#FFFFFF"}}
          startIcon={<Replay />}
        >
          Retry Record Generation
        </Button>
        <Button 
          variant="contained"
          onClick={() => props.continueToNextStep()}
          style={{backgroundColor: "#142e3e", color: "#28c4fc", marginLeft: "20px"}}
        >
          Next Step
        </Button>
      </Grid>
    </>
  )
}